/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'

interface InputProps {
  settings: any
}

type Props = {
  settings: any
}

const AsideMenuMain: React.FC<Props> = ({ settings }) => {
  const intl = useIntl()

  const getIconsFromMenu = (titleText: string) => {
    let title = titleText.toLowerCase()

    if (title === 'menu.dashboard') {
      return '/media/icons/duotone/Design/PenAndRuller.svg'
    } else if (title === 'menu.devices') {
      return '/media/icons/duotone/Devices/itop_device.svg'
    } else if (title === 'menu.snapshot') {
      return '/media/icons/duotone/General/Camera.svg'
    } else if (title === 'menu.download_video') {
      return '/media/icons/duotone/General/Requestfile.svg'
    } else if (title === 'device.track_device') {
      return '/media/icons/duotone/General/Transportation.svg'
    } else if (title === 'menu.map') {
      return '/media/icons/duotone/Interface/Map-Marker.svg'
    } else if (title === 'menu.other_info') {
      return '/media/icons/duotone/Code/Question-circle.svg'
    } else if (title === 'menu.user_logs') {
      return '/media/icons/duotone/General/Activity-log.svg'
    } else if (title === 'menu.file_area') {
      return '/media/icons/duotone/Files/File.svg'
    } else if (title === 'menu.shared_files') {
      return '/media/icons/duotone/Files/File.svg'
    } else if (title === 'menu.magic_links') {
      return '/media/icons/duotone/Files/File.svg'
    } else if (title === 'menu.users') {
      return '/media/icons/duotone/General/User.svg'
    }

    return '/media/icons/duotone/Devices/Server.svg'
  }

  return (
    <>
      {settings.menu.map((menu: any, i: any) => {
        return (
          <React.Fragment key={i}>
            {menu.items ? (
              <AsideMenuItemWithSub
                to={menu.url}
                icon={getIconsFromMenu(menu.title)}
                title={menu.title}
                fontIcon='bi-app-indicator'
              >
                {menu.items.map((subMenu: any, j: any) => {
                  return (
                    <React.Fragment key={`sub-${j}`}>
                      <AsideMenuItem
                        key={j}
                        to={subMenu.url}
                        title={subMenu.title}
                        hasBullet={true}
                      />
                    </React.Fragment>
                  )
                })}
              </AsideMenuItemWithSub>
            ) : (
              <AsideMenuItem
                to={menu.url}
                icon={getIconsFromMenu(menu.title)}
                title={menu.title}
                fontIcon='bi-app-indicator'
              />
            )}
          </React.Fragment>
        )
      })}

      {/* <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotone/Design/PenAndRuller.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />

      <AsideMenuItemWithSub
        to='/device'
        icon='/media/icons/duotone/Devices/Server.svg'
        title={intl.formatMessage({ id: 'MENU.DEVICE' })}
        fontIcon='bi-app-indicator'
      >
        <AsideMenuItem to='/device/list' title='List' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/statistics'
        icon='/media/icons/duotune/general/gen032.svg'
        title={intl.formatMessage({ id: 'MENU.STATISTIC' })}
        fontIcon='bi-app-indicator'
      >
        <AsideMenuItem to='/statistics/status-logs' title='Status Logs' hasBullet={true} />
      </AsideMenuItemWithSub> */}
    </>
  )
}

export { AsideMenuMain }
